<template>
  <div class="school-data">
    <div class="school-data__header">
      <div class="school-data__header__left">
        <h1>Skemalagte timer</h1>
        <changeSchoolYear :white-theme="true" class="marg-1-right"></changeSchoolYear>
      </div>
      <div class="school-data__header__right">
        <p class="d-link" @click="resetDates" v-if="!isDatesPristine">{{ $t('vue2.task_overview.reset') }}</p>
        <Datepickerrange
          :startdate="startDate"
          :enddate="endDate"
          @startchanged="setStartDate"
          @endchanged="setEndDate">
        </Datepickerrange>
      </div>
    </div>
    <div class="loader-container" v-if="isLoading">
      <Loader></Loader>
      <h4>Snup en kop kaffe, det kan tage et par minutter</h4>
    </div>
    <template v-else>
      <h2 class="text-explainer" v-if="filteredCalendars.length < 1">Ingen klasser i skoleåret</h2>
      <ul>
        <li v-for="calendar in filteredCalendars" :key="calendar.id">
          <SchoolDataGrade
            :calendar="calendar"
            :eventsInHash="eventsInHash"
          ></SchoolDataGrade>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import ChangeSchoolYear from '../School/ChangeSchoolYear'
import SchoolDataGrade from './SchoolDataGrade'
import Loader from '../common/Loader'
import docendo from '../../docendo'
import moment from 'moment'
import Datepickerrange from '../datepicker/DatePickerRange'

export default {
  components: {Datepickerrange, Loader, ChangeSchoolYear, SchoolDataGrade},
  data () {
    return {
      events: [],
      isLoading: false,
      startDate: null,
      endDate: null
    }
  },
  computed: {
    schoolId () {
      return this.$route.params.school_id * 1
    },
    user () {
      return this.$store.state.user
    },
    schoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    calendars () {
      return this.$store.state.calendars
    },
    isLoadingSchoolCalenders () {
      return this.$store.state.isLoadingSchoolCalenders
    },
    filteredCalendars () {
      return this.$store.getters.klassCalendars
    },
    schoolYearStartDate () {
      return this.schoolYear ? this.schoolYear.student_time_start : null
    },
    schoolYearEndDate () {
      return this.schoolYear ? this.schoolYear.student_time_end : null
    },
    eventsInHash () {
      let eventsInHash = {}
      this.filteredEvents.forEach((event, idx) => {
        event.calendars.forEach(calendarEvent => {
          const calId = calendarEvent.calendar_id
          const durationInMinutes = moment(event.end).diff(moment(event.start), 'minutes')
          event.v_duration = durationInMinutes
          if (calendarEvent.substitute) {
            event.v_has_substitute = true
          }
          if (!eventsInHash[calId]) {
            eventsInHash[calId] = [event]
          } else {
            eventsInHash[calId].push(event)
          }
        })
      })
      return eventsInHash
    },
    filteredEvents () {
      return this.events.filter(event => {
        const start = moment(event.start)
        const startDate = moment(this.startDate).startOf('day')
        const endDate = moment(this.endDate).endOf('day')
        return start.isSameOrAfter(startDate) && start.isSameOrBefore(endDate)
      })
    },
    isDatesPristine () {
      return this.compareDates(this.schoolYearStartDate, this.startDate) && this.compareDates(this.schoolYearEndDate, this.endDate)
    }
  },
  watch: {
    user () {
      this.$store.dispatch('readSchoolYears', this.schoolId)
      this.$store.dispatch('getSchoolCalendars', this.schoolId)
    },
    filteredCalendars () {
      this.readEvents()
    },
    schoolYearEndDate () {
      this.setDates(this.schoolYearStartDate, this.schoolYearEndDate)
    }
  },
  methods: {
    resetDates () {
      this.setDates(this.schoolYearStartDate, this.schoolYearEndDate)
    },
    setStartDate (date) {
      this.setDates(date, null)
    },
    setEndDate (date) {
      this.setDates(null, date)
    },
    setDates (start, end) {
      if (start) {
        this.startDate = start
      }
      if (end) {
        this.endDate = end
      }
    },
    readEvents () {
      this.isLoading = true
      const start = this.schoolYearStartDate
      const end = this.schoolYearEndDate
      const calendarIds = this.filteredCalendars.map(calendar => calendar.id)
      docendo.calendarEvents2(calendarIds, start, end, null,
        success => {
          this.events = JSON.parse(success).filter(event => event.school_id === this.schoolId)
          this.isLoading = false
        }, failure => {
          console.log('failure', failure)
        })
    },
    compareDates (firstDate, secondDate) {
      return moment(firstDate).format('YYYY-MM-DD') === moment(secondDate).format('YYYY-MM-DD')
    }
  },
  beforeMount () {
    this.$store.dispatch('getUser')
  },
  mounted () {
    this.setDates(this.schoolYearStartDate, this.schoolYearEndDate)
  }
}
</script>


<style scoped>
@import "../../assets/css/variables.css";

.school-data {
  margin: 1rem;
}

.school-data__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1440px;
  min-width: 1100px;
}

.school-data__header__left {
  display: flex;
  align-items: center;
}

.school-data__header h1 {
  margin-right: 1rem;
}

.loader-container {
  text-align: center;
}

.school-data__header__right {
  display: flex;
  align-items: center;
}


.d-link {
  color: var(--blue);
  cursor: pointer;
  margin-right: 1rem;
}

.d-link:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// SchoolData.vue?6894858b